import script from "./IndexBloodingWhiteCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexBloodingWhiteCard.vue?vue&type=script&lang=ts&setup=true"

import "./IndexBloodingWhiteCard.vue?vue&type=style&index=0&id=27bb3fb7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27bb3fb7"]])

export default __exports__